<template>
  <div class="enterpriseAndCommonality">
    <div class="tabWrap">
      <el-tabs style="width: 100%" v-model="activeName">
        <el-tab-pane label="基本信息" name="first" class="firstTab">
          <div class="AddSupplierA">
            <div class="AddSupplierATitle">企业信息</div>
            <div class="AddSupplierAContent">
              <!-- <esoterica @setIsShowHelpExplain="setIsShowHelpExplain"></esoterica> -->
              <el-form
                :model="ruleForm"
                ref="ruleForm"
                label-width="120px"
                class="contactsForm"
              >
                <el-row>
                  <el-col :span="12">
                    <!--公司名称-->
                    <el-form-item class="noMarginBottom" label="公司名称：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.companyName"
                        maxlength="60"
                        placeholder="请输入公司名称"
                        readonly
                      ></el-input>
                    </el-form-item>
                    <!-- <div class="phoneStatement">请按照营业执照上登记的完整名称填写</div> -->
                  </el-col>
                  <el-col :span="12">
                    <!--注册地址-->
                    <el-form-item class="noMarginBottom" label="注册地址：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.registeAddress"
                        maxlength="60"
                        placeholder="请输入注册地址"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <!--办公地址-->
                    <el-form-item class="noMarginBottom" label="办公地址：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.workAddress"
                        maxlength="60"
                        placeholder="请输入办公地址"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <!--办公电话-->
                    <el-form-item label="办公电话：" class="noMarginBottom">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.workPhone"
                        maxlength="20"
                        placeholder="请输入办公电话"
                        @blur="shopNameBlur"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <!--法人姓名-->
                    <el-form-item class="noMarginBottom" label="法人姓名：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.legalPerson"
                        maxlength="12"
                        placeholder="请输入法人姓名"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>

            <div class="AddSupplierATitle">对公户信息</div>
            <div class="AddSupplierAContent">
              <el-form
                :model="ruleForm"
                ref="ruleForm"
                label-width="120px"
                class="contactsForm"
              >
                <el-row>
                  <el-col :span="12">
                    <!--公司名称-->
                    <el-form-item class="noMarginBottom" label="公司名称：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.publicCompanyName"
                        maxlength="60"
                        placeholder="请输入公司名称"
                        readonly
                      ></el-input>
                    </el-form-item>
                    <!-- <div class="phoneStatement">请按照营业执照上登记的完整名称填写</div> -->
                  </el-col>
                  <el-col :span="12">
                    <!--开户行-->
                    <el-form-item class="noMarginBottom" label="开户行：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.publicBank"
                        maxlength="60"
                        placeholder="请输入开户行名称"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <!--开户行地址-->
                    <el-form-item class="noMarginBottom" label="开户行地址：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.publicBankAddress"
                        maxlength="60"
                        placeholder="请输入开户行地址"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <!--开户行账号-->
                    <el-form-item class="noMarginBottom" label="账号：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.publicBankAccount"
                        maxlength="24"
                        placeholder="请输入对公户账号"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <!--税号-->
                    <el-form-item class="noMarginBottom" label="税号：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.publicTaxAccount"
                        maxlength="20"
                        placeholder="请输入对公户税号"
                        @input="publicTaxAccountInput"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <!--开户行行号-->
                    <el-form-item class="noMarginBottom" label="开户行行号：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.publicBankNumber"
                        maxlength="12"
                        placeholder="请输入开户行行号"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <!--对公电话-->
                    <el-form-item class="noMarginBottom" label="对公户电话：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.publicPhone"
                        maxlength="13"
                        placeholder="请输入对公户电话号码"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>

            <div class="AddSupplierATitle">联系人信息</div>
            <div class="AddSupplierAContent">
              <el-form
                :model="ruleForm"
                ref="ruleForm"
                label-width="120px"
                class="contactsForm"
              >
                <el-row>
                  <el-col :span="12">
                    <!--联系人姓名-->
                    <el-form-item class="noMarginBottom" label="联系人姓名：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.contactName"
                        maxlength="24"
                        placeholder="请输入联系人姓名"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <!--联系人电话-->
                    <el-form-item class="noMarginBottom" label="联系人电话：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.contactPhone"
                        maxlength="20"
                        placeholder="请输入联系人电话"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <!--开户行行号-->
                    <el-form-item class="noMarginBottom" label="电子邮箱：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.contactEmail"
                        maxlength="12"
                        placeholder="请输入电子邮箱"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <!--对公电话-->
                    <el-form-item class="noMarginBottom" label="传真电话：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.contactFax"
                        maxlength="13"
                        placeholder="请输入传真电话"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>

            <div class="AddSupplierATitle">开票信息</div>
            <div class="AddSupplierAContent">
              <el-form
                :model="ruleForm"
                ref="ruleForm"
                label-width="120px"
                class="contactsForm"
              >
                <el-row>
                  <el-col :span="12">
                    <el-form-item class="noMarginBottom" label="发票抬头：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.publicCompanyName"
                        maxlength="60"
                        placeholder="请输入发票抬头"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item class="noMarginBottom" label="纳税人识别号：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.publicTaxAccount"
                        maxlength="60"
                        placeholder="请输入纳税人识别号"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item class="noMarginBottom" label="单位地址：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.registeAddress"
                        maxlength="60"
                        placeholder="请输入单位地址"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item class="noMarginBottom" label="电话号码：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.workPhone"
                        maxlength="12"
                        placeholder="请输入电话号码"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item class="noMarginBottom" label="开户银行：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.publicBank"
                        maxlength="60"
                        placeholder="请输入开户银行"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item class="noMarginBottom" label="银行账号：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.publicBankAccount"
                        maxlength="24"
                        placeholder="请输入银行账号"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>

            <div
              class="AddSupplierATitle"
              v-if="this.RouteParam.detailFlag != 'A'"
            >
              图片
            </div>
            <div class="AddSupplierATitle" v-else>材料</div>
            <div class="AddSupplierAContent">
              <el-form
                :model="ruleForm"
                ref="ruleForm"
                label-width="100px"
                class="contactsForm"
              >
                <el-row v-if="this.RouteParam.detailFlag != 'A'">
                  <el-col :span="12">
                    <!--营业执照正本（通过年审）-->
                    <div class="businessBox">
                      <div class="certificateTitle">
                        <span>营业执照正本(通过年审)</span>
                        <el-popover
                          placement="top-start"
                          width="400"
                          trigger="hover"
                        >
                          <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                        </el-popover>
                        <span>：</span>
                      </div>
                      <div class="addImgUploadBox">
                        <el-upload
                          class="addImgUpload"
                          :action="uploadPicUrl"
                          :show-file-list="isShowFileList"
                          :data="uploadData"
                          list-type="text"
                          multiple
                          accept="image/*"
                          :file-list="triangleFileImgList"
                          :disabled="true"
                        >
                        </el-upload>
                        <div
                          class="UploadImgList"
                          v-if="triangleFileList.length != 0"
                        >
                          <div
                            class="UploadImgItem"
                            v-for="(
                              cosmeticSanitationFileItem,
                              cosmeticSanitationFileIndex
                            ) in triangleFileList"
                            :key="
                              'cosmeticSanitationFileItem' +
                              cosmeticSanitationFileIndex
                            "
                          >
                            <div class="UploadImgLeft">
                              <div class="UploadItemImg">
                                <img
                                  :src="cosmeticSanitationFileItem.url"
                                  alt=""
                                />
                              </div>
                              <div class="UploadItemInfo">
                                <div class="UploadItemName">
                                  图片{{ cosmeticSanitationFileIndex + 1 }}
                                </div>
                              </div>
                            </div>
                            <div class="UploadImgBtnList">
                              <div
                                class="previewBtn"
                                @click="
                                  handlePictureCardPreview(
                                    cosmeticSanitationFileItem
                                  )
                                "
                              >
                                预览
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12" style="padding-left: 40px">
                    <!--资质证书（通过年审）-->
                    <div class="businessBox">
                      <div class="certificateTitle">
                        <span>资质证明(通过年审)</span>
                        <el-popover
                          placement="top-start"
                          width="400"
                          trigger="hover"
                        >
                          <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                        </el-popover>
                        <span>：</span>
                      </div>
                      <div class="addImgUploadBox">
                        <el-upload
                          class="addImgUpload"
                          :action="uploadPicUrl"
                          :show-file-list="isShowFileList"
                          :data="uploadData"
                          list-type="text"
                          multiple
                          accept="image/*"
                          :file-list="cosmeticSanitationFileImgList"
                          :disabled="true"
                        >
                        </el-upload>
                        <div
                          class="UploadImgList"
                          v-if="cosmeticSanitationFileList.length != 0"
                        >
                          <div
                            class="UploadImgItem"
                            v-for="(
                              cosmeticSanitationFileItem,
                              cosmeticSanitationFileIndex
                            ) in cosmeticSanitationFileList"
                            :key="
                              'cosmeticSanitationFileItem' +
                              cosmeticSanitationFileIndex
                            "
                          >
                            <div class="UploadImgLeft">
                              <div class="UploadItemImg">
                                <img
                                  :src="cosmeticSanitationFileItem.url"
                                  alt=""
                                />
                              </div>
                              <div class="UploadItemInfo">
                                <div class="UploadItemName">
                                  图片{{ cosmeticSanitationFileIndex + 1 }}
                                </div>
                              </div>
                            </div>
                            <div class="UploadImgBtnList">
                              <div
                                class="previewBtn"
                                @click="
                                  handlePictureCardPreview(
                                    cosmeticSanitationFileItem
                                  )
                                "
                              >
                                预览
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <el-row v-if="this.RouteParam.detailFlag != 'A'">
                  <el-col :span="12">
                    <!--安全生产许可证（有效期内）-->
                    <div class="businessBox">
                      <div class="certificateTitle">
                        <span>安全生产许可证(有效期内)</span>
                        <el-popover
                          placement="top-start"
                          width="400"
                          trigger="hover"
                        >
                          <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                        </el-popover>
                        <span>：</span>
                      </div>
                      <div class="addImgUploadBox">
                        <el-upload
                          class="addImgUpload"
                          :action="uploadPicUrl"
                          :show-file-list="isShowFileList"
                          :data="uploadData"
                          list-type="text"
                          multiple
                          accept="image/*"
                          :file-list="safetyProductionLicenseAttachmentImgList"
                          :disabled="true"
                        >
                        </el-upload>
                        <div
                          class="UploadImgList"
                          v-if="
                            safetyProductionLicenseAttachmentList.length != 0
                          "
                        >
                          <div
                            class="UploadImgItem"
                            v-for="(
                              FileItem, FileIndex
                            ) in safetyProductionLicenseAttachmentList"
                            :key="'FileItem' + FileIndex"
                          >
                            <div class="UploadImgLeft">
                              <div class="UploadItemImg">
                                <img :src="FileItem.url" alt="" />
                              </div>
                              <div class="UploadItemInfo">
                                <div class="UploadItemName">
                                  图片{{ FileIndex + 1 }}
                                </div>
                              </div>
                            </div>
                            <div class="UploadImgBtnList">
                              <div
                                class="previewBtn"
                                @click="handlePictureCardPreview(FileItem)"
                              >
                                预览
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12" style="padding-left: 40px">
                    <!--劳务资质证书（通过年审）-->
                    <div class="businessBox">
                      <div class="certificateTitle">
                        <span>劳务资质证书(通过年审)</span>
                        <el-popover
                          placement="top-start"
                          width="400"
                          trigger="hover"
                        >
                          <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                        </el-popover>
                        <span>：</span>
                      </div>
                      <div class="addImgUploadBox">
                        <el-upload
                          class="addImgUpload"
                          :action="uploadPicUrl"
                          :show-file-list="isShowFileList"
                          :data="uploadData"
                          list-type="text"
                          multiple
                          accept="image/*"
                          :file-list="laborQualificationAttachmentImgList"
                          :disabled="true"
                        >
                        </el-upload>
                        <div
                          class="UploadImgList"
                          v-if="laborQualificationAttachmentList.length != 0"
                        >
                          <div
                            class="UploadImgItem"
                            v-for="(
                              FileItem, FileIndex
                            ) in laborQualificationAttachmentList"
                            :key="'FileItem' + FileIndex"
                          >
                            <div class="UploadImgLeft">
                              <div class="UploadItemImg">
                                <img :src="FileItem.url" alt="" />
                              </div>
                              <div class="UploadItemInfo">
                                <div class="UploadItemName">
                                  图片{{ FileIndex + 1 }}
                                </div>
                              </div>
                            </div>
                            <div class="UploadImgBtnList">
                              <div
                                class="previewBtn"
                                @click="handlePictureCardPreview(FileItem)"
                              >
                                预览
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-row v-if="this.RouteParam.detailFlag != 'A'">
                  <el-col :span="12">
                    <!--法人身份证-->
                    <div class="businessBox">
                      <div class="certificateTitle">
                        <span>法人身份证</span>
                        <el-popover
                          placement="top-start"
                          width="400"
                          trigger="hover"
                        >
                          <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                        </el-popover>
                        <span>：</span>
                      </div>
                      <div class="addImgUploadBox">
                        <el-upload
                          class="addImgUpload"
                          :action="uploadPicUrl"
                          :show-file-list="isShowFileList"
                          :data="uploadData"
                          list-type="text"
                          multiple
                          accept="image/*"
                          :file-list="corporateIdCardAttachmentImgList"
                          :disabled="true"
                        >
                        </el-upload>
                        <div
                          class="UploadImgList"
                          v-if="corporateIdCardAttachmentList.length != 0"
                        >
                          <div
                            class="UploadImgItem"
                            v-for="(
                              FileItem, FileIndex
                            ) in corporateIdCardAttachmentList"
                            :key="'FileItem' + FileIndex"
                          >
                            <div class="UploadImgLeft">
                              <div class="UploadItemImg">
                                <img :src="FileItem.url" alt="" />
                              </div>
                              <div class="UploadItemInfo">
                                <div class="UploadItemName">
                                  图片{{ FileIndex + 1 }}
                                </div>
                              </div>
                            </div>
                            <div class="UploadImgBtnList">
                              <div
                                class="previewBtn"
                                @click="handlePictureCardPreview(FileItem)"
                              >
                                预览
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12" style="padding-left: 40px">
                    <!--委托人身份证-->
                    <div class="businessBox">
                      <div class="certificateTitle">
                        <span>委托人身份证</span>
                        <el-popover
                          placement="top-start"
                          width="400"
                          trigger="hover"
                        >
                          <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                        </el-popover>
                        <span>：</span>
                      </div>
                      <div class="addImgUploadBox">
                        <el-upload
                          class="addImgUpload"
                          :action="uploadPicUrl"
                          :show-file-list="isShowFileList"
                          :data="uploadData"
                          list-type="text"
                          multiple
                          accept="image/*"
                          :file-list="clientIdCardAttachmentImgList"
                          :disabled="true"
                        >
                        </el-upload>
                        <div
                          class="UploadImgList"
                          v-if="clientIdCardAttachmentList.length != 0"
                        >
                          <div
                            class="UploadImgItem"
                            v-for="(
                              FileItem, FileIndex
                            ) in clientIdCardAttachmentList"
                            :key="'FileItem' + FileIndex"
                          >
                            <div class="UploadImgLeft">
                              <div class="UploadItemImg">
                                <img :src="FileItem.url" alt="" />
                              </div>
                              <div class="UploadItemInfo">
                                <div class="UploadItemName">
                                  图片{{ FileIndex + 1 }}
                                </div>
                              </div>
                            </div>
                            <div class="UploadImgBtnList">
                              <div
                                class="previewBtn"
                                @click="handlePictureCardPreview(FileItem)"
                              >
                                预览
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-row v-if="this.RouteParam.detailFlag != 'A'">
                  <el-col :span="12">
                    <!--法人委托书-->
                    <div class="businessBox">
                      <div class="certificateTitle">
                        <span>法人委托书</span>
                        <el-popover
                          placement="top-start"
                          width="400"
                          trigger="hover"
                        >
                          <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                        </el-popover>
                        <span>：</span>
                      </div>
                      <div class="addImgUploadBox">
                        <el-upload
                          class="addImgUpload"
                          :action="uploadPicUrl"
                          :show-file-list="isShowFileList"
                          :data="uploadData"
                          list-type="text"
                          multiple
                          accept="image/*"
                          :file-list="corporateProxyStatementAttachmentImgList"
                          :disabled="true"
                        >
                        </el-upload>
                        <div
                          class="UploadImgList"
                          v-if="
                            corporateProxyStatementAttachmentList.length != 0
                          "
                        >
                          <div
                            class="UploadImgItem"
                            v-for="(
                              FileItem, FileIndex
                            ) in corporateProxyStatementAttachmentList"
                            :key="'FileItem' + FileIndex"
                          >
                            <div class="UploadImgLeft">
                              <div class="UploadItemImg">
                                <img :src="FileItem.url" alt="" />
                              </div>
                              <div class="UploadItemInfo">
                                <div class="UploadItemName">
                                  图片{{ FileIndex + 1 }}
                                </div>
                              </div>
                            </div>
                            <div class="UploadImgBtnList">
                              <div
                                class="previewBtn"
                                @click="handlePictureCardPreview(FileItem)"
                              >
                                预览
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12" style="padding-left: 40px">
                    <!--账户信息和开票信息(盖公章)-->
                    <div class="businessBox">
                      <div class="certificateTitle">
                        <span>账户信息和开票信息(盖公章)</span>
                        <el-popover
                          placement="top-start"
                          width="400"
                          trigger="hover"
                        >
                          <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                        </el-popover>
                        <span>：</span>
                      </div>
                      <div class="addImgUploadBox">
                        <el-upload
                          class="addImgUpload"
                          :action="uploadPicUrl"
                          :show-file-list="isShowFileList"
                          :data="uploadData"
                          list-type="text"
                          multiple
                          accept="image/*"
                          :file-list="
                            accountInformationAndBillingInformationAttachmentImgList
                          "
                        >
                        </el-upload>
                        <div
                          class="UploadImgList"
                          v-if="
                            accountInformationAndBillingInformationAttachmentList.length !=
                            0
                          "
                        >
                          <div
                            class="UploadImgItem"
                            v-for="(
                              FileItem, FileIndex
                            ) in accountInformationAndBillingInformationAttachmentList"
                            :key="'FileItem' + FileIndex"
                          >
                            <div class="UploadImgLeft">
                              <div class="UploadItemImg">
                                <img :src="FileItem.url" alt="" />
                              </div>
                              <div class="UploadItemInfo">
                                <div class="UploadItemName">
                                  图片{{ FileIndex + 1 }}
                                </div>
                              </div>
                            </div>
                            <div class="UploadImgBtnList">
                              <div
                                class="previewBtn"
                                @click="handlePictureCardPreview(FileItem)"
                              >
                                预览
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <div class="businessBox">
                      <div class="certificateTitle">
                        <span v-if="this.RouteParam.detailFlag != 'A'"
                          >其他</span
                        ><span>材料1</span>
                        <el-popover
                          placement="top-start"
                          width="400"
                          trigger="hover"
                        >
                          <div>
                            <div>
                              需提交特殊产品资质的类目请将资质上传在此处，包括全国工业生产许可证、3C、医疗器械生产许可证、化妆品生产企业卫生许可证等，根据具体类目资质要求提交。
                            </div>
                          </div>
                        </el-popover>
                        <span>：</span>
                      </div>
                      <div class="addImgUploadBox">
                        <el-upload
                          class="addImgUpload"
                          :action="uploadPicUrl"
                          :show-file-list="isShowFileList"
                          :data="uploadData"
                          list-type="text"
                          multiple
                          accept="image/*"
                          :file-list="restsFileImgList1"
                        >
                        </el-upload>
                        <div
                          class="UploadImgList"
                          v-if="restsFileList1.length != 0"
                        >
                          <div
                            class="UploadImgItem"
                            v-for="(
                              restsFileItem, restsFileIndex
                            ) in restsFileList1"
                            :key="'restsFileItem' + restsFileIndex"
                          >
                            <div class="UploadImgLeft">
                              <div class="UploadItemImg">
                                <img :src="restsFileItem.url" alt />
                              </div>
                              <div class="UploadItemInfo">
                                <div class="UploadItemName">
                                  图片{{ restsFileIndex + 1 }}
                                </div>
                              </div>
                            </div>
                            <div class="UploadImgBtnList">
                              <div
                                class="previewBtn"
                                @click="handlePictureCardPreview(restsFileItem)"
                              >
                                预览
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12" style="padding-left: 40px">
                    <!--其他材料2-->
                    <div class="businessBox">
                      <div class="certificateTitle">
                        <span v-if="this.RouteParam.detailFlag != 'A'"
                          >其他</span
                        ><span>材料2</span>
                        <el-popover
                          placement="top-start"
                          width="400"
                          trigger="hover"
                        >
                          <div>
                            <div>
                              需提交特殊产品资质的类目请将资质上传在此处，包括全国工业生产许可证、3C、医疗器械生产许可证、化妆品生产企业卫生许可证等，根据具体类目资质要求提交。
                            </div>
                          </div>
                        </el-popover>
                        <span>：</span>
                      </div>
                      <div class="addImgUploadBox">
                        <el-upload
                          class="addImgUpload"
                          :action="uploadPicUrl"
                          :show-file-list="isShowFileList"
                          :data="uploadData"
                          list-type="text"
                          multiple
                          accept="image/*"
                          :file-list="restsFileImgList2"
                          :disabled="true"
                        >
                        </el-upload>
                        <div
                          class="UploadImgList"
                          v-if="restsFileList2.length != 0"
                        >
                          <div
                            class="UploadImgItem"
                            v-for="(
                              restsFileItem, restsFileIndex
                            ) in restsFileList2"
                            :key="'restsFileItem' + restsFileIndex"
                          >
                            <div class="UploadImgLeft">
                              <div class="UploadItemImg">
                                <img :src="restsFileItem.url" alt />
                              </div>
                              <div class="UploadItemInfo">
                                <div class="UploadItemName">
                                  图片{{ restsFileIndex + 1 }}
                                </div>
                              </div>
                            </div>
                            <div class="UploadImgBtnList">
                              <div
                                class="previewBtn"
                                @click="handlePictureCardPreview(restsFileItem)"
                              >
                                预览
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <!--其他材料3-->
                    <div class="businessBox">
                      <div class="certificateTitle">
                        <span v-if="this.RouteParam.detailFlag != 'A'"
                          >其他</span
                        ><span>材料3</span>
                        <el-popover
                          placement="top-start"
                          width="400"
                          trigger="hover"
                        >
                          <div>
                            <div>
                              需提交特殊产品资质的类目请将资质上传在此处，包括全国工业生产许可证、3C、医疗器械生产许可证、化妆品生产企业卫生许可证等，根据具体类目资质要求提交。
                            </div>
                          </div>
                        </el-popover>
                        <span>：</span>
                      </div>
                      <div class="addImgUploadBox">
                        <el-upload
                          class="addImgUpload"
                          :action="uploadPicUrl"
                          :show-file-list="isShowFileList"
                          :data="uploadData"
                          list-type="text"
                          multiple
                          accept="image/*"
                          :file-list="restsFileImgList3"
                          :disabled="true"
                        >
                          <!-- <div class="addImgBox">
                      <div class="addImgIcon">
                        <img
                          src="@/assets/images/supplierImg/addImgIcon.png"
                          alt
                        />
                      </div>
                    </div>
                    <div class="imgIconTxt">
                      图片大小1M以内 支持.jpg .jpeg .png 格式 最多上传2张
                      <span v-show="restsFileList3.length != 0"
                        >（{{ restsFileList3.length }}/2）</span
                      >。
                    </div> -->
                        </el-upload>
                        <div
                          class="UploadImgList"
                          v-if="restsFileList3.length != 0"
                        >
                          <div
                            class="UploadImgItem"
                            v-for="(
                              restsFileItem, restsFileIndex
                            ) in restsFileList3"
                            :key="'restsFileItem' + restsFileIndex"
                          >
                            <div class="UploadImgLeft">
                              <div class="UploadItemImg">
                                <img :src="restsFileItem.url" alt />
                              </div>
                              <div class="UploadItemInfo">
                                <div class="UploadItemName">
                                  图片{{ restsFileIndex + 1 }}
                                </div>
                              </div>
                            </div>
                            <div class="UploadImgBtnList">
                              <div
                                class="previewBtn"
                                @click="handlePictureCardPreview(restsFileItem)"
                              >
                                预览
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-form>

              <!-- <div class="btnList">
          <el-button class="backBtn" type="primary" @click="goBack()">取消</el-button>
          <el-button class="nextBtn" type="primary" @click="submitBtn()">提交</el-button>
        </div>-->
            </div>

            <div class="AddSupplierATitle" v-if="RouteParam.detailFlag == 'B'">
              审核
            </div>
            <div class="AddSupplierATitle" v-if="RouteParam.detailFlag == 'A'">
              分类信息
            </div>
            <div
              class="AddSupplierAContent"
              v-if="
                approveFlag ||
                RouteParam.detailFlag == 'B' ||
                RouteParam.detailFlag == 'A'
              "
            >
              <el-form
                :model="approveForm"
                ref="approveForm"
                label-width="120px"
                class="contactsForm"
              >
                <el-row>
                  <el-col :span="24">
                    <el-row>
                      <div class="time-box">
                        <div
                          class="item"
                          v-for="(item, index) in approveForm.typeRelList"
                          :key="index"
                        >
                          <div class="left">
                            <el-col :span="10">
                              <el-form-item
                                :label="'合作单位分类' + (index + 1) + '：'"
                              >
                                <el-select
                                  v-model="item.topId"
                                  placeholder="请选择一级分类"
                                  filterable
                                  @change="
                                    firstSupplierTypeChange(item.topId, index)
                                  "
                                  :disabled="true"
                                >
                                  <el-option
                                    :label="supplier.typeValue"
                                    :value="supplier.id"
                                    v-for="supplier in firstSupplierTypeList"
                                    :key="supplier.id"
                                  ></el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                            <el-col :span="7">
                              <el-form-item label="" label-width="20px">
                                <el-select
                                  v-model="item.secondId"
                                  filterable
                                  default-first-option
                                  placeholder="请选择二级分类"
                                  @change="
                                    secondSupplierTypeChange(
                                      item.secondId,
                                      index
                                    )
                                  "
                                  :disabled="true"
                                >
                                  <el-option
                                    :label="supplier.typeValue"
                                    :value="supplier.id"
                                    v-for="supplier in secondSupplierTypeList[
                                      index
                                    ]"
                                    :key="supplier.id"
                                  ></el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                            <el-col :span="7">
                              <el-form-item
                                class="noMarginBottom"
                                label
                                label-width="20px"
                              >
                                <el-select
                                  v-model="item.thirdId"
                                  filterable
                                  default-first-option
                                  placeholder="请选择三级分类"
                                  :disabled="true"
                                >
                                  <el-option
                                    :label="supplier.typeValue"
                                    :value="supplier.id"
                                    v-for="supplier in thirdSupplierTypeList[
                                      index
                                    ]"
                                    :key="supplier.id"
                                  ></el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                          </div>
                          <!-- <div class="right" v-if="approveFlag">
                      <el-button
                        v-if="index == 0"
                        @click="addDevPlatTypeList"
                        size="small"
                        icon="el-icon-circle-plus"
                      ></el-button>
                      <el-button
                        v-if="index != 0"
                        @click="delDevPlatTypeList(index)"
                        size="small"
                        icon="el-icon-remove"
                      ></el-button>
                    </div> -->
                          <!-- <div class="right del" @click="delDevPlatTypeList(index)">删除</div> -->
                        </div>
                      </div>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row v-if="RouteParam.detailFlag == 'B'">
                  <el-col :span="8">
                    <el-form-item class="noMarginBottom" label="是否置顶：">
                      <el-col style="padding-left: 20px" :span="8">
                        <el-checkbox
                          v-model="checkedone"
                          style="width: 100px"
                          label="1"
                          disabled
                          >不置顶</el-checkbox
                        >
                      </el-col>
                      <el-col style="padding-left: 60px" :span="8">
                        <el-checkbox
                          v-model="checkedtwo"
                          style="width: 100px"
                          label="1"
                          disabled
                          >置顶</el-checkbox
                        >
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="RouteParam.detailFlag == 'B'">
                  <el-col :span="9">
                    <el-form-item label="审批流：" prop="approveTemplateType">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.approveTemplateName"
                        maxlength="60"
                        placeholder="审批流模板类型"
                        readonly
                      ></el-input>
                      <!-- <el-select
                        v-model="ruleForm.approveTemplateType"
                        filterable
                        default-first-option
                        placeholder="请选择"
                        :disabled="true"
                      >
                      <el-option
                    :label="item.value"
                    :value="item.label"
                    v-for="item in approveTemplate"
                    :key="item.label"
                  ></el-option> -->
                        <!-- <el-option label="劳务" value="1"></el-option>
                        <el-option label="机械" value="2"></el-option>
                        <el-option label="材料" value="3"></el-option> -->
                      <!-- </el-select> -->
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="修改记录"
          name="second"
          style="text-align: left"
          class="secondTab"
        >
          <editSupplierLogList
            :supplierId="supplierId"
            :type="activeName"
          ></editSupplierLogList>
        </el-tab-pane>
        <el-tab-pane
          label="启停记录"
          name="third"
          style="text-align: left"
          class="secondTab"
          v-if="RouteParam.detailFlag !== 'A'"
        >
          <editSupplierLogList
            :supplierId="supplierId"
            :type="activeName"
          ></editSupplierLogList>
        </el-tab-pane>
        <el-tab-pane
          label="审批流程"
          name="fourth"
          style="text-align: left;"
          class="secondTab"
          v-if="RouteParam.detailFlag !== 'A'"
        >
          <div v-if="approveFlag&&approveFlag.includes('currentApprove')">
            <approveItem
              :itemId="supplierId"
              :approveType="approveType"
              @finishApprove="goBack()"
            >
            </approveItem>
          </div>
          <div v-else>
            <approveLine
              :itemId="supplierId"
              :approveType="approveType"
            ></approveLine>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bottomBtn">
      <el-button class="backBtn" type="info" @click="goBack()">关 闭</el-button>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      class="imgMaskDialog"
      title="预览图片"
    >
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import {
  getSupplierTypeList, //获取供应商一级类别列表接口
  getSuppliersubTypeList, //查询子类别列表接口
  getSupplierADetailService, //查询一条甲方供应商
  updateSupplierStatus, //更新供应商审批启用状态
} from "../../../services/supplierMagServices";
import {
  selectSecondDataDetailService, //获取二级数据字典内容
} from "@/services/sysSettingService";

import config from "@/common/config";
import editSupplierLogList from "../commonCell/editSupplierLogList"; //编辑记录tab页

import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //历史审批流程
import approveItem from "@/page/approveComponents/ApproveItem"; //历史审批流程
import { goBackApprove } from "@/page/approveComponents/approve";

export default {
  name: "AddSupplierA",
  components: {
    approveLine, //审批历史流程
    approveItem, //审批
    editSupplierLogList,
  },
  data() {
    return {
      activeName: "first", //活动tab页
      approveFlag: "",
      approveType: "SUPPLIER", //审批类型
      ApproveList: [], //用户列表
      RouteParam: {}, //存储路由跳转参数
      supplierId: 0, //供应商ID
      dialogVisible: false, //预览图片是否异步
      dialogImageUrl: "", //预览图片的路径
      uploadLimit: 1, //拖拽上传最多一张图片
      addImgUploadLimit: 30, //添加上传最多三十张图片
      isShowFileList: false, //是否显示上传成功的列表
      firstSupplierTypeList: [], //一级供应商分类列表
      secondSupplierTypeList: [], //一级供应商分类列表
      thirdSupplierTypeList: [], //一级供应商分类列表
      uploadData: {
        //上传图片的参数
        // source: "merchantPC",
        // business: "shopPic"
      },
      uploadPicUrl: config.baseUrl + "/appuser-web/oss/upload/supplier/pic", //上传图片地址
      triangleFileList: [], //营业执照上传图片成功的数据---三证合一
      triangleFileImgList: [], //营业执照
      cosmeticSanitationFileList: [], //资质证明图片数组
      cosmeticSanitationFileImgList: [], //资质证明
      safetyProductionLicenseAttachmentList: [], //安全生产许可证(通过年审)附件列表
      safetyProductionLicenseAttachmentImgList: [], //安全生产许可证(通过年审)
      laborQualificationAttachmentList: [], //劳务资质证书(通过年审)附件列表
      laborQualificationAttachmentImgList: [], //劳务资质证书(通过年审)
      corporateIdCardAttachmentList: [], //法人身份证附件列表
      corporateIdCardAttachmentImgList: [], //法人身份证
      clientIdCardAttachmentList: [], //委托人身份证附件列表
      clientIdCardAttachmentImgList: [], //委托人身份证
      corporateProxyStatementAttachmentList: [], //法人委托书附件列表
      corporateProxyStatementAttachmentImgList: [], //法人委托书附件列表
      accountInformationAndBillingInformationAttachmentList: [], //账户信息和开票信息(盖公章)
      accountInformationAndBillingInformationAttachmentImgList: [], //账户信息和开票信息(盖公章)

      restsFileList1: [], //其他材料图片数组
      restsFileImgList1: [], //其他资料
      restsFileList2: [], //其他材料图片数组
      restsFileImgList2: [], //其他资料
      restsFileList3: [], //其他材料图片数组
      restsFileImgList3: [], //其他资料
      checkedone: true,
      checkedtwo: false, //默认不置顶
      enterpriseIcon: {
        selectIcon: require("@/assets/images/supplierImg/select.png"),
        selectActiveIcon: require("@/assets/images/supplierImg/selectActive.png"),
      },
      ruleForm: {
        companyName: "", //公司名称
        contactEmail: "", //联系人邮箱
        contactFax: "", //联系人传真
        contactName: "", //联系人姓名
        contactPhone: "", //联系人电话
        idCardAttachmentList: [], //身份证地址列表
        legalPerson: "", //法人
        businessLicenseAttachmentList: [], //营业执照正本(通过年审)附件列表
        qualificationAttachmentList: [], //资质证书(通过年审)附件列表
        safetyProductionLicenseAttachmentList: [], //安全生产许可证(通过年审)附件列表
        laborQualificationAttachmentList: [], //劳务资质证书(通过年审)附件列表
        corporateIdCardAttachmentList: [], //法人身份证附件列表
        clientIdCardAttachmentList: [], //委托人身份证附件列表
        corporateProxyStatementAttachmentList: [], //法人委托书附件列表
        accountInformationAndBillingInformationAttachmentList: [], //账户信息和开票信息(盖公章)
        other1AttachmentList: [], //其他材料1图片地址
        other2AttachmentList: [], //其他材料2图片地址
        other3AttachmentList: [], //其他材料3图片地址
        publicBank: "", //对外开户行
        publicBankAccount: "", //对外账号
        publicBankAddress: "", //对外开户行地址
        publicBankNumber: "", //对外开户行行号
        publicCompanyName: "", //对外公司名称
        publicPhone: "", //对外对公户电话
        publicTaxAccount: "", //对外税号
        registeAddress: "", //注册地址
        workAddress: "", //办公地址
        workPhone: "", //办公电话
        // billAddress: "", //开票单位地址
        // billBank: "", //开票开户银行
        // billBankNumber: "", //开票开户行号
        // billHead: "", //开票抬头
        // billTaxNumber: "", //开票纳税人识别号
        topType: "", //aType 甲方供应商 bType乙方供应商
        approveTemplateType: "", //审批流模板
        approveTemplate: [], //审批流类型查询

      },
      //审批信息
      approveForm: {
        isTop: 0, //默认不置顶
        topType: "", //供应商类型，甲方 乙方
        opinion: "",
        typeRelList: [
          {
            topId: "", //一级分类
            secondId: "", //二级分类
            thirdId: "", //三级级分类
          },
        ], //合作单位分类数组
      },
    };
  },
  mounted() {
    // this.uploadPicUrl = config.baseUrl + "/appuser-web/oss/upload/supplier/pic"; //getUploadUrl();
  },
  computed: {
    headers() {
      return {
        Authorization: sessionStorage.getItem("accessToken"),
      };
    },
  },
  methods: {
    //获取路由跳转传参
    onActive() {
      this.approveFlag = this.tabRouteParam
        ? this.tabRouteParam.approveFlag
        : "";
      this.RouteParam = this.tabRouteParam;
      this.getApproveTempData();
      //编辑 获取一条供应商信息
      this.supplierId = parseInt(this.tabRouteParam.id);
      this.getSupplierDetail(this.supplierId);
      if (
        this.approveFlag ||
        this.RouteParam.detailFlag == "B" ||
        this.RouteParam.detailFlag == "A"
      ) {
        //this.tabRouteParam.approveFlag=true为审核
        this.getSupplierTypeList(); //获取一级分类下拉列表
      }
    },
    //获取一条信息
    getSupplierDetail(supplierId) {
      if (this.RouteParam) {
        // this.approveForm.typeRelList = [];
        let param = {};
        param.supplierId = supplierId;
        getSupplierADetailService(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.ruleForm = res.data;
              this.type = this.ruleForm.topType;
              if (this.ruleForm.isTop == 1) {
                this.checkedtwo = true;
                this.checkedone = false;
              }
              if (
                this.approveFlag ||
                this.RouteParam.detailFlag == "B" ||
                this.RouteParam.detailFlag == "A"
              ) {
                if (
                  null == this.ruleForm.typeRelList ||
                  this.ruleForm.typeRelList.length == 0
                ) {
                  this.approveForm.typeRelList = [];
                  this.approveForm.typeRelList.push({
                    secondId: "",
                    thirdId: "",
                    topId: "",
                  });
                } else {
                  this.approveForm.typeRelList = this.ruleForm.typeRelList;
                  let len = this.ruleForm.typeRelList.length;
                  if (len > 0) {
                    for (let i = 0; i < len; i++) {
                      if (this.approveForm.typeRelList[i].topId) {
                        let topId = this.approveForm.typeRelList[i].topId;
                        this.getsubSupplierTypeList(topId, i, 2);
                      }
                      if (this.approveForm.typeRelList[i].secondId) {
                        let secondId = this.approveForm.typeRelList[i].secondId;
                        this.getsubSupplierTypeList(secondId, i, 3);
                      }
                    }
                  }
                }
              }

              this.init();
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },
    //获取一级供应商分类列表
    getSupplierTypeList() {
      let reqParam = {
        pageIndex: "1",
        pageSize: "50",
      };
      getSupplierTypeList().then(
        (res) => {
          if (res.code == 10000000) {
            this.firstSupplierTypeList = res.data;
            // this.getSupplierDetail(this.supplierId);
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$message.error("系统异常");
        }
      );
    },
    //获取下级供应商分类列表
    getsubSupplierTypeList(val, index, typeLevel) {
      let param = {};
      param.supplierTypeId = val;
      getSuppliersubTypeList(param)
        .then((res) => {
          if (res.code == 10000000) {
            if (typeLevel == 2) {
              this.secondSupplierTypeList[index] = res.data;
              this.$forceUpdate();
              if (null != this.ruleForm.secondId) {
                this.approveForm.typeRelList[index].secondId =
                  this.ruleForm.typeRelList[index].secondId;
              }
            } else {
              this.thirdSupplierTypeList[index] = res.data;
              this.$forceUpdate();
              if (null != this.ruleForm.typeRelList[index].thirdId) {
                this.approveForm.typeRelList[index].thirdId =
                  this.ruleForm.typeRelList[index].thirdId;
              }
            }
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {
          this.$message.error("系统异常");
        });
    },
    //选择完一级分类获取二级分类
    firstSupplierTypeChange(val, index) {
      // this.secondSupplierTypeList[index] = [];
      // this.thirdSupplierTypeList[index] = [];
      this.approveForm.typeRelList[index].secondId = "";
      this.approveForm.typeRelList[index].thirdId = "";
      this.getsubSupplierTypeList(val, index, 2);
    },
    //选择完二级分类获取三级分类
    secondSupplierTypeChange(val, index) {
      // this.thirdSupplierTypeList[index] = [];
      this.approveForm.typeRelList[index].thirdId = "";
      this.getsubSupplierTypeList(val, index, 3);
    },
    /**
     * 新增a一行数据分类
     */
    addDevPlatTypeList() {
      let len = this.approveForm.typeRelList.length;
      if (len == 4) {
        this.$alert("最多添加四条分类信息", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      for (let i = 0; i < len; i++) {
        let val = this.approveForm.typeRelList[i];
        if (val.topId == "") {
          this.$alert("有未选择的一级分类", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }
        // if (val.secondId == "") {
        //   this.$alert("有未选择的二级分类", "提示", {
        //     confirmButtonText: "确定"
        //   });
        //   return;
        // }
        // if (val.thirdId == "") {
        //   this.$alert("有未选择的三级分类", "提示", {
        //     confirmButtonText: "确定"
        //   });
        //   return;
        // }
      }

      this.approveForm.typeRelList.push({
        topId: "",
        secondId: "",
        thirdId: "",
      });
    },
    /**
     * 删除一条数据分类
     */
    delDevPlatTypeList(index) {
      this.approveForm.typeRelList.splice(index, 1);
    },
    //删除图片
    closeBtnClick(closeIndex) {
      if (closeIndex == 1) {
        this.triangleFileList = [];
        this.ruleForm.licenseAttachmentList.splice(0, 1);
      } else if (closeIndex == 2) {
        this.identitycardFrontFileList = [];
        this.ruleForm.idCardAttachmentList.splice(0, 1);
      } else if (closeIndex == 3) {
        this.identitycardReverseFileList = [];
        this.ruleForm.idCardAttachmentList.splice(1, 1);
      } else if (closeIndex == 4) {
        this.triangleFileList1 = [];
        this.ruleForm.licenseAttachmentList.splice(1, 1);
      } else if (closeIndex == 5) {
        this.openAccountFileList = [];
      }
    },
    //预览图片
    previewBtnClick(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    publicTaxAccountInput(value) {
      this.enterpriseRuleForm.publicTaxAccount = value.replace(
        /[^A-Za-z0-9]/g,
        ""
      );
    },
    setIsShowHelpExplain(index) {
      this.$emit("setIsShowHelpExplain", index);
    },
    shopNameBlur() {
      if (!this.ruleForm.shopName) {
        return;
      }
      let params = {
        shopName: this.ruleForm.shopName,
        shopCode: sessionStorage.getItem("shopCode"),
      };
      // checkShopNameServer(params).then(res => {
      //   if (res.resultCode == 0) {
      //     this.isShopNameBool = res.data;
      //     if (res.data) {
      //       this.$message.error("店铺名称重复");
      //     }
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // });
    },
    emptyHistoryData() {
      this.$refs["ruleForm"].resetFields();
      this.$refs["enterpriseRuleForm"].resetFields();
      this.isShopNameBool = false;
      this.triangleFileList = []; //上传图片成功的数据---三证合一
      this.identitycardFrontFileList = []; //身份证正面
      this.identitycardReverseFileList = []; //身份证反面
      this.taxpayerFileList = []; //纳税人资格证
      this.brandFileList = []; //商标图片数组
      this.brandFileImgList = [];
      this.qualityFileList = []; //质检图片数组
      this.qualityFileImgList = [];
      this.restsFileList = []; //其他资质数组
      this.restsFileImgList = [];
      this.openAccountFileList = []; //开户许可图片
      this.signinAddress = {
        //注册地址数据
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
      };
      this.businessAddress = {
        //办公地址数据
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
      };
      this.openingBankAddress = {
        //开户行地址数据
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
      };
    },
    //初始化数据
    init() {
      this.triangleFileList = [];
      this.safetyProductionLicenseAttachmentList = []; //安全涩生产许可证
      this.laborQualificationAttachmentList = []; //劳务资质证书
      this.cosmeticSanitationFileList = []; //资质证明图片地址
      this.corporateIdCardAttachmentList = []; //法人身份证附件列表

      this.clientIdCardAttachmentList = []; //委托人身份证附件列表
      this.corporateProxyStatementAttachmentList = []; //法人委托书附件列表
      this.accountInformationAndBillingInformationAttachmentList = []; //账户信息和开票信息(盖公章)

      this.restsFileList1 = []; //其他材料1图片数组
      this.restsFileList2 = []; //其他材料2图片数组
      this.restsFileList3 = []; //其他材料2图片数组

      this.triangleFileImgList = [];
      this.safetyProductionLicenseAttachmentImgList = []; //安全涩生产许可证
      this.laborQualificationAttachmentImgList = []; //劳务资质证书
      this.cosmeticSanitationFileImgList = []; //资质证明图片地址
      this.corporateIdCardAttachmentImgList = []; //法人身份证附件列表

      this.clientIdCardAttachmentImgList = []; //委托人身份证附件列表
      this.corporateProxyStatementAttachmentImgList = []; //法人委托书附件列表
      this.accountInformationAndBillingInformationAttachmentImgList = []; //账户信息和开票信息(盖公章)

      this.restsFileImgList1 = []; //其他材料1图片数组
      this.restsFileImgList2 = []; //其他材料2图片数组
      this.restsFileImgList3 = []; //其他材料2图片数组

      this.isShopNameBool = false;
      //资质证明
      if (this.ruleForm.qualificationAttachmentList) {
        let len = this.ruleForm.qualificationAttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.cosmeticSanitationFileList.push({
            url: this.ruleForm.qualificationAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.cosmeticSanitationFileImgList.push({
            url: this.ruleForm.qualificationAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.qualificationAttachmentList = [];
      }
      //营业执照正本
      if (this.ruleForm.businessLicenseAttachmentList) {
        let len = this.ruleForm.businessLicenseAttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.triangleFileList.push({
            url: this.ruleForm.businessLicenseAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.triangleFileImgList.push({
            url: this.ruleForm.businessLicenseAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.businessLicenseAttachmentList = [];
      }

      //安全生产许可正
      if (this.ruleForm.safetyProductionLicenseAttachmentList) {
        let len = this.ruleForm.safetyProductionLicenseAttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.safetyProductionLicenseAttachmentList.push({
            url: this.ruleForm.safetyProductionLicenseAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.safetyProductionLicenseAttachmentImgList.push({
            url: this.ruleForm.safetyProductionLicenseAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.safetyProductionLicenseAttachmentList = [];
      }

      //劳务资质证书
      if (this.ruleForm.laborQualificationAttachmentList) {
        let len = this.ruleForm.laborQualificationAttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.laborQualificationAttachmentList.push({
            url: this.ruleForm.laborQualificationAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.laborQualificationAttachmentImgList.push({
            url: this.ruleForm.laborQualificationAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.laborQualificationAttachmentList = [];
      }

      //法人身份证
      if (this.ruleForm.corporateIdCardAttachmentList) {
        let len = this.ruleForm.corporateIdCardAttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.corporateIdCardAttachmentList.push({
            url: this.ruleForm.corporateIdCardAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.corporateIdCardAttachmentImgList.push({
            url: this.ruleForm.corporateIdCardAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.corporateIdCardAttachmentList = [];
      }

      //委托人身份证
      if (this.ruleForm.clientIdCardAttachmentList) {
        let len = this.ruleForm.clientIdCardAttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.clientIdCardAttachmentList.push({
            url: this.ruleForm.clientIdCardAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.clientIdCardAttachmentImgList.push({
            url: this.ruleForm.clientIdCardAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.clientIdCardAttachmentList = [];
      }

      //法人委托书
      if (this.ruleForm.corporateProxyStatementAttachmentList) {
        let len = this.ruleForm.corporateProxyStatementAttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.corporateProxyStatementAttachmentList.push({
            url: this.ruleForm.corporateProxyStatementAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.corporateProxyStatementAttachmentImgList.push({
            url: this.ruleForm.corporateProxyStatementAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.corporateProxyStatementAttachmentList = [];
      }

      //账户信息和开票信息
      if (this.ruleForm.accountInformationAndBillingInformationAttachmentList) {
        let len =
          this.ruleForm.accountInformationAndBillingInformationAttachmentList
            .length;
        for (let i = 0; i < len; i++) {
          this.accountInformationAndBillingInformationAttachmentList.push({
            url: this.ruleForm
              .accountInformationAndBillingInformationAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.accountInformationAndBillingInformationAttachmentImgList.push({
            url: this.ruleForm
              .accountInformationAndBillingInformationAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.accountInformationAndBillingInformationAttachmentList =
          [];
      }

      if (this.ruleForm.other1AttachmentList) {
        let len = this.ruleForm.other1AttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.restsFileList1.push({
            url: this.ruleForm.other1AttachmentList[i].attachmentItemDisplay,
          });
          this.restsFileImgList1.push({
            url: this.ruleForm.other1AttachmentList[i].attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.other1AttachmentList = [];
      }
      if (this.ruleForm.other2AttachmentList) {
        let len = this.ruleForm.other2AttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.restsFileList2.push({
            url: this.ruleForm.other2AttachmentList[i].attachmentItemDisplay,
          });
          this.restsFileImgList2.push({
            url: this.ruleForm.other2AttachmentList[i].attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.other2AttachmentList = [];
      }
      if (this.ruleForm.other3AttachmentList) {
        let len = this.ruleForm.other3AttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.restsFileList3.push({
            url: this.ruleForm.other3AttachmentList[i].attachmentItemDisplay,
          });
          this.restsFileImgList3.push({
            url: this.ruleForm.other3AttachmentList[i].attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.other3AttachmentList = [];
      }
    },
    setRuleFormLongTime() {
      this.ruleForm.longTime = !this.ruleForm.longTime;
      if (this.ruleForm.longTime) {
        this.ruleForm.validityTime = [];
      }
    },
    setEnterpriseRuleFormLongTime() {
      this.enterpriseRuleForm.longTime = !this.enterpriseRuleForm.longTime;
      if (this.enterpriseRuleForm.longTime) {
        this.enterpriseRuleForm.validityTime = [];
      }
    },
    fileChanged(file, fileList) {
      console.log(file);
    },
    uploadFaildAction(err, file, fileList) {
      this.$message.error(err.msg);
    },
    triangleUploadSuccess(res, file, fileList) {
      if (res.code == 10000000) {
        this.ruleForm.licenseForOperationUrl = res.data;
        this.triangleFileList = [];
        this.triangleFileList.push({ url: res.data });
      } else {
        this.$alert("三证合一营业执照上传失败");
      }
    },
    identitycardFrontUploadSuccess(res) {
      if (res.code == 0) {
        this.ruleForm.idCardFrontUrl = res.data;
        this.identitycardFrontFileList = [];
        this.identitycardFrontFileList.push({ url: res.data });
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("身份证正面照片上传失败");
      }
    },
    identitycardReverseUploadSuccess(res) {
      if (res.code == 0) {
        this.ruleForm.idCardBackUrl = res.data;
        this.identitycardReverseFileList = [];
        this.identitycardReverseFileList.push({ url: res.data });
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("身份证正面照片上传失败");
      }
    },
    exceedFilesNum() {
      this.$alert("最多上传30张图片"),
        "错误",
        {
          confirmButtonText: "确定",
        };
    },
    // 图片大小不能超过1M
    beforeUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (testmsg == "jpeg" || testmsg == "jpg" || testmsg == "png") {
        if (!isLt2M) {
          this.$alert("图片大小不能超过1M", {
            confirmButtonText: "确定",
          });
          return false;
        } else {
          return true;
        }
      } else {
        this.$alert("仅支持jpg、jpeg和png格式的图片", {
          confirmButtonText: "确定",
        });
        return false;
      }
    },

    // 图片大小不能超过5M
    beforeMaxUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (testmsg == "jpeg" || testmsg == "jpg" || testmsg == "png") {
        if (!isLt2M) {
          this.$alert("图片大小不能超过5M", {
            confirmButtonText: "确定",
          });
          return false;
        } else {
          return true;
        }
      } else {
        this.$alert("仅支持jpg、jpeg和png格式的图片", {
          confirmButtonText: "确定",
        });
        return false;
      }
    },

    dateFormat() {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
    },
    handleCheckChange(val) {
      //复选框选择改变事件
      if (val == 0) {
        //不置顶
        if (this.checkedone) {
          this.approveForm.isTop = 0;
          this.checkedtwo = false;
          this.TopSupplier(this.approveForm.isTop);
          this.$forceUpdate();
        }
      } else {
        if (this.checkedtwo) {
          this.approveForm.isTop = 1;
          this.checkedone = false;
          this.TopSupplier(this.approveForm.isTop);
          this.$forceUpdate();
        } else {
          this.approveForm.isTop = 0;
        }
      }
    },
    //置顶供应商
    TopSupplier(val) {
      // let msg = "确认启用该供应商吗?";
      let param = {
        id: this.supplierId,
        isTop: val, //sessionStorage.getItem("userCode"),
      };
      // if (val == 0) {
      //   msg = "确认停用该供应商吗?";
      // }
      updateSupplierStatus(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.$alert("操作成功", "提示", {
              confirmButtonText: "确定",
            });
          } else if (res.code > 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },

     //获取审批流模板数据
     getApproveTempData(data) {
      let params = {};
      // params.dictId = this.dictId;
      params.label = 'supplier';
      selectSecondDataDetailService(params)
        .then(
          (res) => {
            if (res.code == 10000000) {
              this.approveTemplate = res.data;
            } else {
              this.$alert(res.msg, "提示");
            }
          },
          (err) => {
            this.$message.error("系统异常");
          }
        )
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },

    //取消按钮
    goBack() {
      if (this.RouteParam.detailFlag == "A") {
        //甲方详情
        this.bus.$emit("tabClose", "supplierDetail");
        this.bus.$emit("navMenuChange", {
          routeId: "supplierAListPage",
        });
      } else if (this.RouteParam.approveFlag == "currentApprove_super") {
        this.bus.$emit("tabClose", "supplierBApprove");
        this.bus.$emit("navMenuChange", {
          routeId: "supplierAApprove",
        });
      } else if (this.RouteParam.approveFlag) {
        //审核列表页面审核按钮跳转过来跳转回审核页面
        goBackApprove(this.approveFlag, "supplierBApprove");
      } else if (this.RouteParam.detailFlag == "D") {
        //审核详情
        //审核列表页面双击跳转进来跳转回审核
        this.bus.$emit("tabClose", "supplierAApproveDetail");
        this.bus.$emit("navMenuChange", {
          routeId: "supplierAApprove",
        });
      } else if (this.RouteParam.detailFlag == "C") {
        //我的企业信息
        this.bus.$emit("tabClose", "supplierDetail");
        this.bus.$emit("navMenuChange", {
          routeId: "supplierBListPage",
        });
      } else if (this.RouteParam.detailFlag == "B") {
        //企业信息（乙）维护
        this.bus.$emit("tabClose", "supplierAApproveDetail");
        this.bus.$emit("navMenuChange", {
          routeId: "supplierBSelfMag",
        });
      } else {
        this.bus.$emit("tabClose", "supplierBApprove");
        // this.bus.$emit("navMenuChange", {
        //   routeId: "supplierBSelfMag"
        // });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.enterpriseAndCommonality {
  height: 100%;
  background-color: white;
  overflow: hidden;
  // height: 100%;
  .tabWrap {
    height: calc(100% - 60px);
    /deep/ .el-tabs--top {
      height: 100%;
      overflow: hidden;
      .el-tabs__content {
        height: calc(100% - 80px);
        padding: 0 20px 20px;
        overflow: auto;
      }
    }
    /deep/ .el-tabs__item {
      padding: 0 20px;
    }
    .secondTab {
      width: 93%;
    }
  }
  .bottomBtn {
    position: fixed;
    // border-top: 1px solid #e6e6e6;
    // width: 60%;
    height: 44px;
    line-height: 44px;
    text-align: center;
    left: 620px;
    bottom: 28px;
  }
}
/deep/.ApproveItem .bottomBtn {
  bottom: 32px;
  z-index: 10;
  left: 500px;
}
@media only screen and(max-width:1680px) {
  .AddSupplierA {
    width: 100%;
  }
}
.AddSupplierA {
  background: rgba(255, 255, 255, 1);
  width: 90%;
  .time-box {
    //  display: flex;
    // height: 180px;
    overflow-y: auto;
    flex: 1;

    .item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-right: 40px;
    width: 90%;
  }

  .right {
    height: 32px;
    line-height: 32px;
    width: 60px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 20px;
  }

  .add {
    background-color: #38b1c9;
    border-radius: 2px;
    color: #ecf5ff;
  }
  .el-form-item {
    width: 100%;
  }

  .el-checkbox {
    line-height: 40px;
  }

  .el-textarea {
    min-width: 0px !important;
  }
  .el-cascader {
    width: 100%;
  }

  .el-form-item__content {
    width: calc(100% - 110px);

    .el-input {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
  }

  .AddSupplierATitle {
    height: 44px;
    padding-left: 24px;
    box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
    border-radius: 2px 2px 0px 0px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 44px;
    text-align: left;
  }
  .AddSupplierAContent {
    padding: 24px;
  }
  /deep/.daterangePicker {
    width: 255px;
    height: 32px;
    .el-input__icon {
      display: flex;
      align-items: center;
    }
    .el-range-separator {
      display: flex;
      align-items: center;
    }
  }

  .businessBox {
    display: flex;
    margin-bottom: 24px;
    .businessTitle {
      width: 195px;
      padding-right: 12px;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      flex-wrap: wrap;
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606266;
        line-height: 22px;
      }
      .startTxt {
        color: #f56c6c;
        margin-right: 4px;
      }
      img {
        width: 14px;
        height: 14px;
        margin: 4px 2px 0 4px;
      }
    }
    .certificateTitle {
      width: 210px;
      min-width: 100px;
      padding-right: 12px;
      box-sizing: border-box;
      text-align: right;
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606266;
        line-height: 22px;
        min-width: 60px;
      }
      img {
        width: 14px;
        height: 14px;
        margin: 4px 2px 0 4px;
      }
    }
    .secondUpload {
      margin-top: 0px;
    }
    /deep/.upload-demo {
      .el-upload-dragger {
        width: 380px;
        height: 194px;
        background: rgba(251, 251, 251, 1);
        border-radius: 2px;
        border: 1px dashed rgba(217, 217, 217, 1);
        .fileImgIcon {
          margin: 39px 0 21px 0;
        }
        .dragTxt {
          width: 242px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 20px;
          margin: 0 auto;
        }
        .imgSizeTxt {
          width: 242px;
          height: 34px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 17px;
          margin: 2px auto 0;
        }
      }
      .uploadImgBox {
        width: 100%;
        position: relative;
        img {
          width: 100%;
        }
        .coloseAndPreviewBtnList {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          position: absolute;
          top: 157px;
          div {
            width: 56px;
            height: 26px;
            background: rgba(0, 0, 0, 1);
            border-radius: 13px;
            opacity: 0.8;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            line-height: 26px;
          }
          .closeBtn {
            margin-right: 8px;
          }
          .PreviewBtn {
            margin-right: 10px;
          }
        }
      }
    }
    /deep/.selectBox {
      .selectItem {
        width: 121px;
        height: 32px;
        margin-right: 8px;
        .el-input__inner {
          width: 121px;
          height: 32px;
        }
        .el-input__icon {
          line-height: 32px;
        }
      }
      .selectItem:nth-child(3n) {
        margin-right: 0px;
      }
      .textareaTxt {
        width: 380px;
        margin-top: 10px;
        textarea {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
    }
  }
  .addImgUploadBox {
    .addImgUpload {
      .addImgBox {
        width: 50px;
        height: 50px;
        border-radius: 2px;
        border: 1px dashed rgba(223, 223, 228, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        .addImgIcon {
          width: 18px;
          height: 18px;
          img {
            width: 18px;
            height: 18px;
          }
        }
      }
      .imgIconTxt {
        margin-top: 7px;
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 14px;
      }
    }
    .UploadImgList {
      margin-top: 16px;
      .UploadImgItem {
        width: 380px;
        height: 66px;
        background: rgba(251, 251, 251, 1);
        border-radius: 4px;
        border: 1px dashed rgba(217, 217, 217, 1);
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        .UploadImgLeft {
          height: 66px;
          display: flex;
          align-items: center;
          .UploadItemImg {
            width: 54px;
            height: 54px;
            padding-left: 8px;
            overflow: hidden;
            img {
              width: 54px;
            }
          }
          .UploadItemInfo {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            margin-left: 13px;
            .UploadItemName {
              width: 200px;
              height: 20px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 20px;
              text-align: left;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .UploadItemSize {
              height: 17px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 17px;
              text-align: left;
              margin-top: 6px;
            }
          }
        }
        .UploadImgBtnList {
          display: flex;
          align-items: flex-end;
          div {
            width: 28px;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 20px;
            margin-bottom: 11px;
            cursor: pointer;
          }
          .previewBtn {
            margin-left: 12px;
            margin-right: 13px;
          }
        }
      }
      .UploadImgItem:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
